export function arrayToMap(arr: [], key: string = 'uuid') {
	return arr.reduce((obj: any, item: any) => {
		obj[item[key]] = item;
		return obj;
	}, {});
}
